// extracted by mini-css-extract-plugin
export default {"methodIcon":"login-methods_methodIcon__RNbgs"};